var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import styles from './styles-user-settings.less';
import * as React from 'react';
import * as _ from 'underscore';
import classNames from 'classnames';
import Input from '../../components/input';
import Button, { ButtonSize, ButtonType } from '../../components/button';
import users from '../../js/user.gql';
import Snackbar from '../../components/snackbar';
import Link from '../../components/link';
import config from '../../js/config';
var UserSettings = /** @class */ (function (_super) {
    __extends(UserSettings, _super);
    function UserSettings(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            userTag: _this.props.context.user.userTag || _this.props.context.user.name || 'someone',
            savingInProgress: false,
            successState: {},
            errorState: {}
        };
        _.bindAll.apply(_, __spreadArray([_this], _.functions(_this), false));
        return _this;
    }
    UserSettings.prototype.handleSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.setState({ savingInProgress: true });
                        return [4 /*yield*/, users.updateLoggedInUser({ userTag: this.state.userTag })];
                    case 1:
                        result = _a.sent();
                        return [4 /*yield*/, this.props.context.requestUpdate()];
                    case 2:
                        _a.sent();
                        this.setState({
                            userTag: result.userTag,
                            savingInProgress: false,
                            successState: {
                                successMessage: 'Profile updated'
                            }
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        this.setState({
                            errorState: {
                                errorMessage: "Sorry, something didn\u2019t go well. Please, try again"
                            }
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    UserSettings.prototype._clearErrorState = function () {
        this.setState({
            errorState: {},
            savingInProgress: false
        });
    };
    UserSettings.prototype._clearSuccessState = function () {
        this.setState({
            successState: {},
            savingInProgress: false
        });
    };
    UserSettings.prototype.saveDisabled = function () {
        return !(this.state.userTag != '');
    };
    UserSettings.prototype.render = function () {
        var _a;
        var _this = this;
        var globalClass = "".concat(styles.wrapperClass, "_user-settings");
        var userSettingsClasses = classNames((_a = {},
            _a["".concat(globalClass)] = true,
            _a["".concat(this.props.className)] = !!this.props.className,
            _a));
        return (React.createElement("div", { className: "".concat(userSettingsClasses) },
            React.createElement("div", { className: "".concat(globalClass, "__header") },
                React.createElement("div", { className: "".concat(globalClass, "__header__avatar") }, this.props.context.user.avatar &&
                    React.createElement("img", { className: "".concat(globalClass, "__header__img-source"), src: this.props.context.user.avatar })),
                React.createElement("div", { className: "".concat(globalClass, "__name-block") },
                    React.createElement("div", { className: "".concat(globalClass, "__header__name") },
                        "Hello ",
                        this.props.context.user.name,
                        ","),
                    React.createElement("div", { className: "".concat(globalClass, "__header__email") }, this.props.context.user.email))),
            React.createElement("div", { className: "".concat(globalClass, "__field") },
                React.createElement("div", { className: "".concat(globalClass, "__field__composite-input") },
                    React.createElement(Input, { className: "".concat(globalClass, "__field__input"), id: 'slug-input-field', value: this.state.userTag, onChange: function (value, event) { return _this.setState({ userTag: value }); }, prefix: "".concat(config.displayServiceUrl, "/"), label: "Personal shortlink prefix", placeholder: "me" }))),
            config.target != 'extension' && React.createElement("div", { className: "".concat(globalClass, "__download") },
                React.createElement("span", { className: "".concat(globalClass, "__download__label") }, "Install browser extension"),
                React.createElement(Link, { href: config.extensionLink, className: "".concat(globalClass, "__download__link") },
                    React.createElement("img", { src: "/assets/chrome_store.jpg", srcSet: "/assets/chrome_store@2x.jpg 2x", className: "".concat(globalClass, "__download__link-content") }))),
            React.createElement("div", { className: "".concat(globalClass, "__submit") },
                React.createElement(Button, { isDisabled: this.saveDisabled(), isLoading: this.state.savingInProgress, size: ButtonSize.LARGE, type: ButtonType.PRIMARY, label: 'Save profile settings', onClick: this.handleSave, fullWidth: true })),
            React.createElement("div", { className: "".concat(globalClass, "__snackbar-container") },
                this.state.errorState.errorMessage &&
                    React.createElement(Snackbar, { className: "".concat(globalClass, "__profile-error"), message: this.state.errorState.errorMessage, canDismiss: true, onDismiss: this._clearErrorState }),
                this.state.successState.successMessage &&
                    React.createElement(Snackbar, { className: "".concat(globalClass, "__profile-success"), message: this.state.successState.successMessage, canDismiss: true, timer: 2000, onDismiss: this._clearSuccessState }))));
    };
    return UserSettings;
}(React.Component));
export default UserSettings;
